var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#3F3F3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#5D6067"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 33.4931C34.9867 33.4931 34.08 33.8931 33.3867 34.5197L23.88 28.9864C23.9467 28.6797 24 28.3731 24 28.0531C24 27.7331 23.9467 27.4264 23.88 27.1197L33.28 21.6397C34 22.3064 34.9467 22.7197 36 22.7197C38.2133 22.7197 40 20.9331 40 18.7197C40 16.5064 38.2133 14.7197 36 14.7197C33.7867 14.7197 32 16.5064 32 18.7197C32 19.0397 32.0533 19.3464 32.12 19.6531L22.72 25.1331C22 24.4664 21.0533 24.0531 20 24.0531C17.7867 24.0531 16 25.8397 16 28.0531C16 30.2664 17.7867 32.0531 20 32.0531C21.0533 32.0531 22 31.6397 22.72 30.9731L32.2133 36.5197C32.1467 36.7997 32.1067 37.0931 32.1067 37.3864C32.1067 39.5331 33.8533 41.2797 36 41.2797C38.1467 41.2797 39.8933 39.5331 39.8933 37.3864C39.8933 35.2397 38.1467 33.4931 36 33.4931ZM36 17.3864C36.7333 17.3864 37.3333 17.9864 37.3333 18.7197C37.3333 19.4531 36.7333 20.0531 36 20.0531C35.2667 20.0531 34.6667 19.4531 34.6667 18.7197C34.6667 17.9864 35.2667 17.3864 36 17.3864ZM20 29.3864C19.2667 29.3864 18.6667 28.7864 18.6667 28.0531C18.6667 27.3197 19.2667 26.7197 20 26.7197C20.7333 26.7197 21.3333 27.3197 21.3333 28.0531C21.3333 28.7864 20.7333 29.3864 20 29.3864ZM36 38.7464C35.2667 38.7464 34.6667 38.1464 34.6667 37.4131C34.6667 36.6797 35.2667 36.0797 36 36.0797C36.7333 36.0797 37.3333 36.6797 37.3333 37.4131C37.3333 38.1464 36.7333 38.7464 36 38.7464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCircleIcon);
export default __webpack_public_path__ + "static/media/shareCircleIcon.68957f0117fdac571dac166e8158beec.svg";
export { ForwardRef as ReactComponent };